import { IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonLoading, IonPage, IonRefresher, IonRefresherContent, IonTitle, IonToast, IonToolbar, useIonModal } from '@ionic/react';
import RosterCardComponent from '../components/RosterCardComponent';
import './Timesheet.css';
import { RouteComponentProps, useHistory } from 'react-router';
import { Api } from '../services/api';
import React, { useEffect, useState } from 'react';
import { add, checkmarkCircle, sadOutline } from 'ionicons/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faBell, faClockFour, faHandshakeAlt, faHSquare, } from '@fortawesome/free-solid-svg-icons';
import ToolbarComponent from '../components/ToolbarComponent';
import RosterAddComponent from '../components/RosterAddComponent';
import AddShiftComponent from '../components/AddShiftComponent';
import moment from 'moment';
import AddLeaveComponent from '../components/AddLeaveComponent';


interface LoginPageProps extends RouteComponentProps {
  api: Api
}

const Timesheet: React.FC<LoginPageProps> = ({api}) => {

  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const [presentLeave, dismissLeave] = useIonModal(AddLeaveComponent, {
    api,
    onDismiss: () => {dismissLeave()},
  });

  useEffect(()=>{    
    if(api.authentication?.user?.id){
      setLoading(true);
      api.rosters.getRosters(api.authentication?.user?.id)
        .finally(() => setLoading(false));
    }
  }, []);

  const notApprovedRosters = () => {
    if(api.rosters?.approvalRosters && api.rosters?.approvalRosters?.length > 0){
      const filteredArray = api.rosters?.approvalRosters?.filter((item, index)=>{
        return item.accepted === null && (moment(item.date).format("YYYY-MM-DD") >=  moment(new Date()).format("YYYY-MM-DD"));
      });
      return filteredArray.length;
    }
    return 0;
  }

  // Admins: the full job allocation form, for adding a shift for someone else
  const [present, dismiss] = useIonModal(RosterAddComponent, {
    api,
    onDismiss: () => {dismiss()},
  });

  // Everyone: "Add my shift", one screen. A started shift opens straight away so they can clock out later.
  const [shiftMessage, setShiftMessage] = useState('');
  const [presentAddShift, dismissAddShift] = useIonModal(AddShiftComponent, {
    api,
    onDismiss: (result?: { action: string; timesheet_id: number; message?: string }) => {
      dismissAddShift();
      if (!result) {
        return;
      }
      if (result.action === 'start' || result.action === 'open') {
        history.push(`/rosters/${result.timesheet_id}`);
      }
      if (result.message) {
        setShiftMessage(result.message);
      }
    },
    onFullForm: () => {
      dismissAddShift();
      present();
    },
  });
  
  return (
    <IonPage>
      <IonHeader >
        <ToolbarComponent icon={faClockFour} title='Timesheet' backbutton={false} backlink=''/>
      </IonHeader>
      <IonContent fullscreen className="custom-content">
        <IonRefresher slot="fixed" onIonRefresh={(e) => api.rosters.doRefresh(e, api.authentication?.user?.id)}>
            <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <div className="image-section">
          <div className="content-container">
            <h6><FontAwesomeIcon icon={faHandshakeAlt} shake /> Welcome <b>{api.authentication.user?.name},</b></h6>
            <p>You have <b className='fade-in-out'>{api.rosters?.rosterToday?.length} </b> activity today</p>
          </div>
        </div>
       {(notApprovedRosters() > 0) && (<div className='bg-danger p-2 text-center font-weight-bold text-white' onClick={()=> history.push('/approval')}><FontAwesomeIcon icon={faBell} shake /> <span className='fade-in-out'>You have {notApprovedRosters()} {(notApprovedRosters() > 1) ? 'dockets': 'docket'} waiting for approval!</span></div>)}

        {
          (api.rosters?.rosterToday?.length)? 
          (<>
            {api.rosters?.rosterToday?.map((item, index) => (
                <div key={index}>
                  <RosterCardComponent id={index} roster={item} />
                </div>
              )
            )}
          </>) 
          : 
          (<>
            <div className="text-center mt-4 text-muted">
              <b>No Rosters Today!!</b> <IonIcon icon={sadOutline} />
            </div>
          </>)
        }
        {/**/}
        <IonToast
          isOpen={!!shiftMessage}
          message={shiftMessage}
          duration={4000}
          position="top"
          color="success"
          icon={checkmarkCircle}
          onDidDismiss={() => setShiftMessage('')}
        />
        <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Please wait...'}
        />
      </IonContent>
      {<IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => presentAddShift()} aria-label="Add my shift">
            <span style={{marginTop : -10}}> <span style={{fontSize: 20}}>+</span> <br/>Shift</span>
          </IonFabButton>
        </IonFab>}
        <IonFab vertical="bottom" horizontal="start" slot="fixed" >
          <IonFabButton onClick={() => presentLeave()} className="custom-darkgreen-fab">
            <span style={{marginTop : -10}}> <span style={{fontSize: 20}}>+</span> <br/>Leave</span>
          </IonFabButton>
        </IonFab>
    </IonPage>
  );
};

export default Timesheet;
